import { registerQuery, useQuery } from 'academy-common-lib/utils/DataFetchingClient';
import { useLearningContentCardModels } from 'academy-common-lib/features/cards/hooks/useLearningContentCardModels';
// @ts-expect-error Could not find a declaration file for module
import inboundImageUrl from 'bender-url!../../../../images/pngs/Inbound.png';
const mockAnnouncementsData = [{
  id: 1,
  imageSrc: inboundImageUrl,
  title: 'INBOUND 2025',
  body: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
  ctaText: 'See all content',
  ctaURL: 'https://www.hubspot.com/inbound-2025',
  isActive: true,
  featuredContentId: '1',
  featuredContentType: 'LESSON',
  language: 'en'
}];

//to make request in earlyRequester.js when api is ready
export const GET_ANNOUNCEMENTS_QUERY = registerQuery({
  fieldName: 'announcements',
  args: [],
  fetcher() {
    //to change when api is ready
    return new Promise(resolve => {
      setTimeout(() => {
        resolve({
          announcements: mockAnnouncementsData
        });
      }, 1500);
    });
  }
});
export function useAnnouncements() {
  var _finalCardModels;
  const {
    data,
    error
  } = useQuery(GET_ANNOUNCEMENTS_QUERY);
  const announcements = (data === null || data === void 0 ? void 0 : data.announcements) || [];
  const featuredAnnouncement = announcements[0];
  let featuredContentItem = null;
  if (featuredAnnouncement !== null && featuredAnnouncement !== void 0 && featuredAnnouncement.featuredContentId && featuredAnnouncement !== null && featuredAnnouncement !== void 0 && featuredAnnouncement.featuredContentType) {
    const {
      featuredContentId,
      featuredContentType,
      language
    } = featuredAnnouncement;
    featuredContentItem = {
      id: Number(featuredContentId),
      type: featuredContentType,
      language
    };
  }
  const {
    cardModels,
    cardModelsLoading,
    cardModelsError
  } = useLearningContentCardModels({
    items: featuredContentItem ? [featuredContentItem] : [],
    skip: !featuredContentItem
  });
  let finalCardModels = cardModels;
  if (featuredContentItem && (!cardModels || cardModels.length === 0)) {
    finalCardModels = [{
      id: featuredContentItem.id,
      type: featuredContentItem.type,
      name: `Mock ${featuredContentItem.type} ${featuredContentItem.id}`,
      description: 'This is a mock card for testing the announcement feature',
      language: featuredContentItem.language,
      previewThumbnailRectangleUrl: inboundImageUrl,
      duration: 1800,
      // 30 minutes
      subCategories: ['INBOUND_MARKETING'],
      progress: null,
      visibility: 'PUBLIC',
      isDeprecated: false,
      certification: featuredContentItem.type === 'TRACK',
      lessonCount: featuredContentItem.type === 'TRACK' ? 5 : undefined,
      lessonType: featuredContentItem.type === 'LESSON' ? ['LESSON'] : undefined
    }];
  }
  return {
    announcements: announcements || [],
    error,
    featuredCardModel: ((_finalCardModels = finalCardModels) === null || _finalCardModels === void 0 ? void 0 : _finalCardModels[0]) || null,
    loading: cardModelsLoading,
    cardModelsError
  };
}